import { CategoryGroupCreatePage } from "@/features/category-group/pages/CategoryGroupCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-group/create")({
	component: CategoryGroupCreatePage,
});
